import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import toastr from '../toastr'
import TextInput from '../../component/dccore-form/textInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import TimePicker from '../../component/timePicker.vue'
import ErrorsCollectionForm from '../../component/dccore-form/errorsCollectionForm.vue'
import MultiSelect from '../../component/dccore-form/multiselect.vue'
import CheckboxRadio from 'vue-checkbox-radio'

if ($('#region_form').length) {
  Vue.use(VueResource)
  Vue.use(CheckboxRadio)

  new Vue({
    el: '#region_form',
    components: {
      RingLoader,
      TextInput,
      Checkbox,
      TimePicker,
      ErrorsCollectionForm,
      MultiSelect
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {

        },
        options: {
          types: [],
          errors: {},
        }
      },
      deliveryTypes: {},
      entityId: null,
      times: null,
      enabledTimes: {},
      brands: []
    },
    mounted: function () {
      this.entityId = $('#entity_id').val()
      this.createTimes()

    },
    methods: {
      updateRegion: function (redirect) {
        this.loading++

        let url = Routing.generate('api_patch_region', {
          id: this.entityId,
        })

        this.form.entity.times = this.transformTimes(this.entityId)

        if (!this.form.entity.global) {
          this.form.entity.selectedBrands = [];
          this.form.entity.brands = [];
          this.refresh();
        }

        let data = { data: this.form.entity }
        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('region_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getRegion() {
        this.loading++
        let url = Routing.generate('api_get_region', { id: this.entityId,
          context: 'edit' })
        this.$http.get(url).then(response => {

          this.reverseTransformTimes(response.data.times)

          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        this.loading++
        const url = Routing.generate('api_get_brands', { context: 'dropdown' })

        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      async createTimes() {
        this.loading++
        this.deliveryTypes = await this.getDeliveryTypes()
        let times = {}
        let enabledTimes = {}

        this.deliveryTypes.forEach(deliveryType => {
          times[deliveryType.id] = {}
          enabledTimes[deliveryType.id] = {}
          times[deliveryType.id] = []
          enabledTimes[deliveryType.id] = false
        })

        this.times = times
        this.enabledTimes = enabledTimes
        this.loading--
        this.getRegion()
        this.getBrands();
      },
      getDeliveryTypes: function() {
        let url = Routing.generate('api_get_tags', { 'type' : 'delivery_type' })

        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      addTime(deliveryId) {
        this.times[deliveryId].push(this.createEmptyTime(deliveryId))
        this.refresh()
      },
      removeTime(deliveryTypeId, index) {
        this.times[deliveryTypeId].splice(index, 1)
        this.enabledTimes[deliveryTypeId] =
                  this.times[deliveryTypeId].length > 0
        this.refresh()
      },
      createEmptyTime(deliveryTypeId) {
        return {
          'timeFrom' : null,
          'timeTo'   : null,
          'interval'  : null,
          'isWeekend'  : false,
          'deliveryTypeId' : deliveryTypeId,
        }
      },
      getDeliveryName(id) {
        for (let i = 0; i < this.deliveryTypes.length ; i++) {
          if (Number(this.deliveryTypes[i].id) === Number(id)) {
            return this.deliveryTypes[i].value
          }
        }

        return null
      },
      clearTimes(deliveryTypeId) {
        this.times[deliveryTypeId] = []
      },
      toggleTimes(deliveryTypeId) {
        this.times[deliveryTypeId] =
                  this.times[deliveryTypeId]
                    .map(t => Object.assign(t, {
                      deletedAt:
                          this.enabledTimes[deliveryTypeId] ?
                            null :
                            (new Date()).toISOString()
                    }))
      },
      transformTimes(regionId) {
        let data = []
        this.deliveryTypes.forEach(deliveryType => {
          this.times[deliveryType.id].forEach(time => {
            data.push({
              deliveryType : deliveryType.id,
              timeFrom : time.timeFrom,
              timeTo: time.timeTo,
              interval : time.interval,
              deletedAt : time.deletedAt,
              region : regionId,
              isWeekend: time.isWeekend,
            })
          })
        })

        return data
      },
      reverseTransformTimes(times) {
        let index = 0
        times.forEach(time => {
          if (!time.deletedAt) {
            this.enabledTimes[time.deliveryTypeId] = true
          }
          this.times[time.deliveryTypeId].push({
            deliveryType : time.deliveryTypeId,
            timeFrom : time.timeFrom,
            timeTo: time.timeTo,
            interval : time.interval,
            region : time.regionId,
            deletedAt : time.deletedAt,
            isWeekend: time.isWeekend,
            index: index++
          })
        })
      },
      setShowOption(value) {
        this.form.entity.showSinceOption = value === 'showSinceOption'
        this.form.entity.showSinceToOption = value !== 'showSinceOption'
      },
    }
  })
}
